<template>
    <!-- PC提现设置 -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部栏 -->
        <div class="container-fluid mt-3">
            <div class="row shengse mt-2">
                <div class="py-2 d-flex justify-content-between align-items-center topbar-pc">
                    <div class="lf go-back" @click="goBack">
                        <i class="fa fa-bullhorn"></i> 推广中心
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体：两栏 -->
        <div class="settings-shell">

            <!-- ✅ 新增：主体页头（与下方组件相同位置） -->
            <div class="page-head">
                <div class="ph-left">
                    <div class="ph-title">提现设置</div>
                    <div class="ph-sub">请完善收款信息，用于提现到账（USDT 可不填写姓名）</div>
                </div>

                <div class="ph-right">
                    <button class="btn-soft" @click="goWithdraw">
                        <i class="fa fa-credit-card"></i>申请提现
                    </button>
                    <button class="btn-soft" @click="goMyWallet">
                        <i class="fa fa-rmb"></i> 我的钱包
                    </button>
                </div>
            </div>
            <div class="settings-grid">
                <!-- 左：表单 -->
                <div class="col-left">
                    <!-- 真实姓名 -->
                    <div class="card">
                        <div class="card-head">
                            <div class="card-title">真实姓名设置</div>
                        </div>

                        <div class="form-row">
                            <div class="label">真实姓名</div>
                            <input
                                    class="input"
                                    v-model.trim="form.realName"
                                    type="text"
                                    placeholder="请输入真实姓名"
                            />
                        </div>
                    </div>

                    <!-- USDT -->
                    <div class="card">
                        <div class="card-head">
                            <div class="card-title">USDT账号设置</div>
                        </div>

                        <div class="form-row">
                            <div class="label">USDT地址</div>
                            <input
                                    class="input"
                                    v-model.trim="form.usdtAddress"
                                    type="text"
                                    placeholder="请输入账号"
                            />
                        </div>
                    </div>

                    <!-- 支付宝 -->
                    <div class="card">
                        <div class="card-head">
                            <div class="card-title">支付宝账户设置</div>
                        </div>

                        <div class="form-row">
                            <div class="label">支付宝账号</div>
                            <input
                                    class="input"
                                    v-model.trim="form.alipayAccount"
                                    type="text"
                                    placeholder="请输入支付宝账号"
                            />
                        </div>
                    </div>

                    <!-- 银行 -->
                    <div class="card">
                        <div class="card-head">
                            <div class="card-title">银行账户设置</div>
                        </div>

                        <!-- 开户行：点击弹出下拉 -->
                        <div class="form-row click" ref="bankCell" @click="chooseBank">
                            <div class="label">开户行</div>

                            <div class="right">
                            <span class="right-text" :class="{ 'is-placeholder': !form.bankName }">
                             {{ form.bankName || "请选择开户行" }}
                            </span>

                                <!-- ✅ 清空/撤回按钮：仅当已经选择了开户行时显示 -->
                                <button
                                        v-if="form.bankName"
                                        class="btn-clear"
                                        type="button"
                                        @click.stop="clearBankInfo"
                                        title="清空开户行和银行卡号"
                                >
                                    清空
                                </button>

                                <i class="fa fa-angle-right arrow2"></i>
                            </div>
                        </div>


                        <!-- 账号 -->
                        <div class="form-row">
                            <div class="label">账号</div>
                            <input
                                    class="input"
                                    :value="form.bankAccount"
                                    @input="onBankAccountInput($event.target.value)"
                                    type="text"
                                    placeholder="请输入账号"
                            />

                        </div>

                        <!-- 提交 -->
                        <div class="submit-wrap">
                            <button class="btn-submit" @click="onSubmit">提交</button>
                            <div class="submit-hint">提示：请确认信息填写无误，提交后用于提现收款。</div>
                        </div>
                    </div>
                </div>

                <!-- 右：说明/提示 -->
                <div class="col-right">
                    <div class="card side-card">
                        <div class="side-title">设置说明</div>

                        <div class="side-kv">
                            <div class="kv-row">
                                <div class="k">真实姓名</div>
                                <div class="v">用于支付宝或银行卡收款信息核验</div>
                            </div>
                            <div class="kv-row">
                                <div class="k">USDT 地址</div>
                                <div class="v">请核对链地址,可不提交姓名</div>
                            </div>
                            <div class="kv-row">
                                <div class="k">支付宝</div>
                                <div class="v">姓名需一致</div>
                            </div>
                            <div class="kv-row">
                                <div class="k">银行卡</div>
                                <div class="v">开户行、卡号、姓名需一致</div>
                            </div>
                        </div>

                        <div class="side-divider"></div>

                        <div class="side-tips">
                            <div class="tips-title">温馨提示</div>
                            <ul class="tips-list">
                                <li>请确保账户信息真实有效，避免到账失败。</li>
                                <li>USDT 地址较长，粘贴后建议核对首尾字符。</li>
                                <li>如需更换账户信息，请重新提交覆盖更新。</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="gray-gap"></div>
        </div>
    </div>

    <!-- 银行下拉（贴着开户行下方） -->
    <transition name="fade">
        <div v-if="showBankPicker" class="bank-mask" @click="closeBankPicker">
            <div
                    class="bank-panel bank-panel-dropdown"
                    :style="bankPanelStyle"
                    @click.stop
            >
                <div class="bank-title">请选择开户行</div>

                <div class="bank-list">
                    <div
                            v-for="item in bankOptions"
                            :key="item"
                            class="bank-item"
                            :class="{ active: item === form.bankName }"
                            @click="selectBank(item)"
                    >
                        {{ item }}
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <div class="gongxi2"></div>
    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";

    export default {
        name: "PPWalletSettings",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                form: {
                    realName: "",
                    usdtAddress: "",
                    alipayAccount: "",
                    bankName: "",
                    bankAccount: ""
                },

                showBankPicker: false,
                bankOptions: ["工商银行", "建设银行", "中国银行", "交通银行", "农业银行", "邮政银行"],

                bankPanelStyle: {
                    top: "0px",
                    left: "0px",
                    width: "420px"
                },

                currentUserId: null,
                saving: false,
                loadingProfile: false
            };
        },

        computed: {
            ...mapGetters(["getUser"])
        },

        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            const token = localStorage.getItem("token");
            if (!token) {
                this.$router.replace("/login");
                return;
            }

            this.currentUserId = this.resolveUserIdSafe();

            // ✅ 页面打开拉回填（如果你暂时没写回填接口可注释）
            await this.loadWithdrawProfile();
        },

        methods: {
            // ================== 通用提示（兼容 toast/alert） ==================
            toast(msg) {
                return this.$toast ? this.$toast(msg) : alert(msg);
            },

            // ================== 更稳的 userId 获取 ==================
            resolveUserIdSafe() {
                // 1) Vuex
                const u = this.getUser || {};
                if (u && u.id) return u.id;

                // 2) localStorage 常见存法
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }
                return null;
            },

            // ================== ✅ 核心修复：银行卡号输入变化 ==================
            onBankAccountInput(val) {
                const v = (val || "").trim();
                this.form.bankAccount = val; // 保留用户原输入（可包含空格），校验时再 trim

                // ⭐ 关键：银行卡号被清空 => 同步清空开户行
                if (!v) {
                    this.form.bankName = "";
                }
            },

            // （可选）如果你想支持“撤回开户行”也连带清空卡号
            clearBankInfo() {
                this.form.bankName = "";
                this.form.bankAccount = "";
            },

            // ================== ✅ 回填：从后端取 withdraw_profile ==================
            async loadWithdrawProfile() {
                if (this.loadingProfile) return;
                this.loadingProfile = true;

                try {
                    // 你后端：GET /platform/withdraw/profile?userId=xx（可选）
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;
                    const res = await http.get("/platform/withdraw/profile", params);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        // 回填失败不强制弹窗，避免“打开就弹”
                        console.warn("[WithdrawProfile] load failed:", json);
                        return;
                    }

                    const d = json.data || {};

                    // 映射字段（按你表字段和前端字段）
                    this.form.realName = d.realName || "";
                    this.form.usdtAddress = d.usdtAddress || "";
                    this.form.alipayAccount = d.alipayAccount || "";
                    this.form.bankName = d.bankName || "";
                    this.form.bankAccount = d.bankAccount || "";

                    // ✅ 兜底：若银行账号为空却有 bankName，强制清空 bankName
                    if (!String(this.form.bankAccount || "").trim()) {
                        this.form.bankName = "";
                    }
                } catch (e) {
                    console.error("[WithdrawProfile] error:", e);
                } finally {
                    this.loadingProfile = false;
                }
            },

            // ================== ✅ 提交：保存 withdraw_profile ==================
            async onSubmit() {
                if (this.saving) return;

                const f = this.form || {};
                const realName = (f.realName || "").trim();
                const usdt = (f.usdtAddress || "").trim();
                const alipay = (f.alipayAccount || "").trim();
                const bankName = (f.bankName || "").trim();
                const bankAccount = (f.bankAccount || "").trim();

                const hasUSDT = !!usdt;
                const hasAlipay = !!alipay;
                const hasBankAny = !!bankName || !!bankAccount;
                const hasAnyAccount = hasUSDT || hasAlipay || hasBankAny;

                // ---------- 1) 全空 ----------
                if (!realName && !hasAnyAccount) {
                    return this.toast("请填写真实姓名，并至少选择一种账户填写账号");
                }

                // ---------- 2) 只填真实姓名 ----------
                if (realName && !hasAnyAccount) {
                    return this.toast("至少选择一种账户填写账号");
                }

                // ---------- 3) 银行块：填了任意项则必须全填 ----------
                if (hasBankAny) {
                    if (!bankName) return this.toast("请选择开户行");
                    if (!bankAccount) return this.toast("请输入银行卡号");
                }

                // ---------- 4) 如果包含 银行或支付宝，则真实姓名必须非空 ----------
                if ((hasBankAny || hasAlipay) && !realName) {
                    return this.toast("请输入真实姓名");
                }

                // ---------- 5) 常理格式校验 ----------
                if (realName) {
                    if (!this.isChinaRealName(realName)) {
                        return this.toast("真实姓名格式不正确，请填写中文姓名");
                    }
                }

                if (hasAlipay) {
                    if (!this.isValidAlipayAccount(alipay)) {
                        return this.toast("支付宝账号格式不正确（请输入手机号或邮箱）");
                    }
                }

                if (hasBankAny) {
                    if (!this.isValidBankCard(bankAccount)) {
                        return this.toast("银行卡号格式不正确");
                    }
                }

                if (hasUSDT) {
                    if (!this.isValidUSDTAddress(usdt)) {
                        return this.toast("USDT地址格式不正确");
                    }
                }

                // ✅ ✅ ✅ 最关键兜底（防止“只剩开户行”这种脏状态提交）
                // 银行卡号为空 => 强制清空开户行
                if (!bankAccount) {
                    this.form.bankName = "";
                }

                // ---------- 6) 通过校验：组装提交 payload ----------
                const payload = {
                    realName: realName || "",
                    usdtAddress: usdt || "",
                    alipayAccount: alipay || "",
                    bankName: (bankAccount ? bankName : "") || "",
                    bankAccount: bankAccount || ""
                };

                // ✅ 保存到后端
                this.saving = true;
                try {
                    // 你后端：POST /platform/withdraw/profile?userId=xx（可选）
                    const url = this.currentUserId
                        ? `/platform/withdraw/profile?userId=${this.currentUserId}`
                        : `/platform/withdraw/profile`;

                    const res = await http.post(url, payload);
                    const json = res.data;

                    if (!json || json.status !== 1) {
                        return this.toast((json && json.msg) || "提交失败，请稍后重试");
                    }

                    this.toast("已提交");
                } catch (e) {
                    console.error(e);
                    this.toast("提交失败，请稍后重试");
                } finally {
                    this.saving = false;
                }
            },

            // ========= 真实姓名校验 =========
            isChinaRealName(name) {
                const s = String(name).trim();
                if (s.length < 2 || s.length > 10) return false;
                return /^[\u4e00-\u9fa5]{2,10}([\u00b7·][\u4e00-\u9fa5]{2,10})?$/.test(s);
            },

            // ========= 支付宝账号校验 =========
            isValidAlipayAccount(v) {
                const s = String(v).trim();
                const isPhone = /^1[3-9]\d{9}$/.test(s);
                const isEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(s);
                return isPhone || isEmail;
            },

            // ========= 银行卡号校验 =========
            isValidBankCard(v) {
                const s = String(v).replace(/\s/g, "");
                if (!/^\d+$/.test(s)) return false;
                return s.length >= 10 && s.length <= 30;
            },

            // ========= USDT 地址校验 =========
            isValidUSDTAddress(v) {
                const s = String(v).trim();
                const isERC20 = /^0x[a-fA-F0-9]{40}$/.test(s);
                const isTRC20 = /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(s);
                return isERC20 || isTRC20;
            },

            // ================== UI：银行下拉 ==================
            chooseBank() {
                this.showBankPicker = true;

                this.$nextTick(() => {
                    const el = this.$refs.bankCell;
                    if (!el) return;

                    const rect = el.getBoundingClientRect();
                    const width = Math.max(420, Math.min(rect.width, 680));
                    const top = rect.bottom + 8;
                    const left = rect.left;

                    const maxLeft = window.innerWidth - width - 12;
                    const safeLeft = Math.max(12, Math.min(left, maxLeft));
                    const safeTop = Math.min(top, window.innerHeight - 460);

                    this.bankPanelStyle = {
                        top: `${safeTop}px`,
                        left: `${safeLeft}px`,
                        width: `${width}px`
                    };
                });
            },

            selectBank(name) {
                this.form.bankName = name;
                this.showBankPicker = false;

                if (!this.form.bankAccount) {
                    // 等用户后续输入银行卡号
                }
            }
            ,

            closeBankPicker() {
                this.showBankPicker = false;
            },

            // ================== 跳转 ==================
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },

            goMyWallet() {
                if (this.$router) this.$router.push("/MyWallet");
                else window.location.href = "/MyWallet";
            },

            goWithdraw() {
                this.$router.push({ path: "/WalletWithdrawal" });
            }
        }
    };
</script>

<style scoped>
    body {
        font-family: Arial, sans-serif;
    }
    /* ✅ 页头（复制下方组件的样式即可） */
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 14px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 2px;
        margin-bottom: 12px; /* 建议加一点间距，让下面内容更舒服 */
    }
    .ph-left { min-width: 0; }
    .ph-title { font-size: 16px; font-weight: 900; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }
    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }

    .btn-soft {
        height: 36px;
        padding: 0 12px;
        border-radius: 2px;
        border: 1px solid #eee;
        background: #fafafa;
        font-size: 13px;
        cursor: pointer;
        color: #333;
        display: inline-flex;
        align-items: center;
    }
    .btn-soft .fa { margin-right: 8px; color: #00c26f; }
    .btn-soft:active { opacity: 0.8; }
    .fa {
        margin-right: 6px;
    }
    .lf{
        font-weight: 900;
    }
    .gongxi2 {
        height: 20px;
    }

    /* 最大容器的左右内边距 */
    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .errong {
            margin-top: 80px;
        }
    }

    /* 顶部栏（PC更像后台） */
    .topbar-pc {
        position: relative;
    }
    .go-back {
        cursor: pointer;
        color: #333;
        font-size: 15px;
        display: inline-flex;
        align-items: center;
    }
    .go-back:active {
        opacity: 0.75;
    }
    .top-title {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        font-size: 16px;
        font-weight: 900;
        color: #00c26f;
    }
    .top-right {
        cursor: pointer;
        color: #00c26f;
        font-size: 14px;
        display: inline-flex;
        align-items: center;
    }
    .arrow {
        margin-left: 6px;
        font-size: 18px;
        color: #aaa;
    }

    /* 主体区域 */
    .settings-shell {
        background: #efefef;
        border-radius: 16px;
        margin-top: 10px;
        /*padding: 16px;*/
    }

    .settings-grid {
        display: grid;
        grid-template-columns: 1.6fr 1fr;
        gap: 16px;
    }

    @media (max-width: 992px) {
        .settings-grid {
            grid-template-columns: 1fr;
        }
    }

    /* 卡片 */
    .card {
        background: #fff;
        border-radius: 2px;
        box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
        padding: 16px;
    }
    .card + .card {
        margin-top: 12px;
    }

    .card-head {
        padding-bottom: 12px;
        border-bottom: 1px solid #f2f2f2;
        margin-bottom: 12px;
    }
    .card-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
    }

    /* 表单行 */
    .form-row {
        min-height: 52px;
        display: flex;
        align-items: center;
        border-top: 1px solid #f6f6f6;
        padding: 0 2px;
    }
    .form-row:first-of-type {
        border-top: 0;
    }
    .form-row.click {
        cursor: pointer;
    }
    .form-row.click:hover {
        background: #fafafa;
    }

    .label {
        width: 110px;
        font-size: 14px;
        font-weight: 800;
        color: #111;
        flex: 0 0 auto;
    }

    .input {
        flex: 1;
        border: 1px solid #eee;
        height: 40px;
        border-radius: 10px;
        padding: 0 12px;
        outline: none;
        font-size: 14px;
        color: #666;
    }
    .input:focus {
        border-color: rgba(0, 194, 111, 0.5);
        box-shadow: 0 0 0 3px rgba(0, 194, 111, 0.08);
    }
    .input::placeholder {
        color: #b8b8b8;
    }

    /* 开户行右侧展示 */
    .right {
        margin-left: auto;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        width: 260px;
    }
    .right-text {
        font-size: 14px;
        color: #666;
    }
    .right-text.placeholder {
        color: #b8b8b8;
    }
    .arrow2 {
        font-size: 22px;
        color: #c9c9c9;
        margin-right: 0;
    }

    /* 提交 */
    .submit-wrap {
        margin-top: 14px;
    }
    .btn-submit {
        width: 100%;
        height: 46px;
        border: none;
        border-radius: 10px;
        font-size: 16px;
        font-weight: 900;
        color: #fff;
        background: linear-gradient(90deg, #f15a5a, #ff8a66);
        box-shadow: 0 6px 16px rgba(241, 90, 90, 0.18);
        cursor: pointer;
    }
    .btn-submit:active {
        transform: translateY(1px);
        opacity: 0.92;
    }
    .submit-hint {
        margin-top: 10px;
        font-size: 12px;
        color: #999;
        line-height: 1.6;
    }

    /* 右侧卡片 */
    .side-card .side-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
        margin-bottom: 10px;
    }
    .side-kv {
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        padding: 10px 12px;
    }
    .kv-row {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        padding: 8px 0;
        border-bottom: 1px dashed #f0f0f0;
    }
    .kv-row:last-child {
        border-bottom: 0;
    }
    .k {
        font-size: 13px;
        color: #777;
    }
    .v {
        font-size: 13px;
        color: #111;
        font-weight: 700;
        text-align: right;
    }

    .side-divider {
        height: 1px;
        background: #f2f2f2;
        margin: 14px 0;
    }

    .tips-title {
        font-size: 13px;
        font-weight: 900;
        color: #111;
        margin-bottom: 8px;
    }
    .tips-list {
        margin: 0;
        padding-left: 18px;
        color: #777;
        font-size: 13px;
        line-height: 1.8;
    }

    .side-actions {
        margin-top: 14px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }
    .btn-outline {
        height: 36px;
        padding: 0 12px;
        border-radius: 10px;
        border: 1px solid #e9e9e9;
        background: #fff;
        font-size: 13px;
        cursor: pointer;
    }
    .btn-outline:active {
        opacity: 0.75;
    }

    .gray-gap {
        height: 18px;
    }

    /* ✅ 银行下拉：遮罩（透明，点空白关闭） */
    .bank-mask {
        position: fixed;
        inset: 0;
        background: transparent;
        z-index: 9999;
    }

    /* ✅ 下拉面板（PC版更像菜单） */
    .bank-panel.bank-panel-dropdown {
        position: fixed;
        background: #fff;
        border: 1px solid #dcdcdc;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);
    }

    /* 标题 */
    .bank-title {
        padding: 12px 14px;
        font-size: 15px;
        font-weight: 900;
        color: #111;
        border-bottom: 1px solid #e9e9e9;
    }

    /* 列表 */
    .bank-list {
        max-height: 360px;
        overflow: auto;
    }

    /* 列表项（PC更适中，不用22px那么大） */
    .bank-item {
        padding: 12px 14px;
        font-size: 14px;
        color: #111;
        cursor: pointer;
        user-select: none;
    }
    .bank-item:hover {
        background: #f5f7ff;
    }
    /* 选中项高亮 */
    .bank-item.active {
        background: rgba(47, 111, 237, 0.12);
        color: #2f6fed;
        font-weight: 800;
    }
    .right-text {
        font-size: 14px;
        color: #666;
    }

    /* 用自己的类名，避免撞 Bootstrap 的 .placeholder */
    .right-text.is-placeholder {
        color: #b8b8b8;
    }


    /* 动画 */
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.18s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    /* ===============================
 * 开户行「清空」按钮（弱操作）
 * =============================== */

    /* 按钮本体 */
    .btn-clear {
        margin-left: 10px;          /* 与银行名的间距 */
        padding: 0;                 /* 纯文本感 */
        border: none;               /* 去掉黑边框 */
        background: transparent;    /* 透明背景 */

        font-size: 12px;            /* 比正文略小 */
        font-weight: 400;           /* 常规字重 */
        color: #bdbdbd;             /* 浅灰，不抢眼 */

        cursor: pointer;
        line-height: 1;
        white-space: nowrap;        /* 防止换行 */
        user-select: none;

        outline: none;              /* 去掉点击蓝框 */
    }

    /* hover：轻微强调，但不张扬 */
    .btn-clear:hover {
        color: #8f8f8f;
        text-decoration: underline; /* 提示“这是可点的” */
    }

    /* active：轻微反馈 */
    .btn-clear:active {
        color: #6f6f6f;
    }

    /* 禁用态（如果你将来用到） */
    .btn-clear:disabled {
        color: #dcdcdc;
        cursor: not-allowed;
        text-decoration: none;
    }

    /* ===============================
     * 可选：如果你用的是 “× 清空”
     * =============================== */
    .btn-clear::before {
        /* 默认不显示任何内容，这里只是占位说明 */
    }

</style>
